import { i18nInit } from 'i18nSetup';
import i18next from 'i18next';

import accessOnDemandRecordingsImg from 'images/TrackmanEvents/accessOnDemandRecordings.png';
import exploreUpcomingEventsImg from 'images/TrackmanEvents/exploreUpcomingEvents.png';
import introducingEventsImg from 'images/TrackmanEvents/introducingEvents.png';

import introducingLearningHubImg from 'images/WhatsNewModal/IntroducingLearningHub.png';
import completeLessonsImg from 'images/WhatsNewModal/CompleteLessons.png';
import earnCertificatesImg from 'images/WhatsNewModal/EarnCertificates.png';

i18nInit();

export const getCurrentNewFeatureContent = (feature: string) => whatsNewModalConfig[feature];

export const whatsNewModalConfig = {
  events: [
    {
      stepTitle: i18next.t('IntroducingEvents', { ns: 'whatsNewModal' }),
      stepDescription: i18next.t('StayUpdatedOnTheLatestEvents', { ns: 'whatsNewModal' }),
      stepImage: introducingEventsImg,
    },
    {
      stepTitle: i18next.t('ExploreUpcomingEvents', { ns: 'whatsNewModal' }),
      stepDescription: i18next.t('SignUpForUpcomingEvents', { ns: 'whatsNewModal' }),
      stepImage: exploreUpcomingEventsImg,
    },
    {
      stepTitle: i18next.t('AccessOnDemandContent', { ns: 'whatsNewModal' }),
      stepDescription: i18next.t('BrowseOurOnDemandLibrary', { ns: 'whatsNewModal' }),
      stepImage: accessOnDemandRecordingsImg,
    },
  ],
  learningHub: [
    {
      stepTitle: i18next.t('IntroducingLearningHub', { ns: 'whatsNewModal' }),
      stepDescription: i18next.t('DiscoverUpdatedLearningExperience', { ns: 'whatsNewModal' }),
      stepImage: introducingLearningHubImg,
    },
    {
      stepTitle: i18next.t('CompleteLessons', { ns: 'whatsNewModal' }),
      stepDescription: i18next.t('IncreaseYourKnowledgeWithLessons', { ns: 'whatsNewModal' }),
      stepImage: completeLessonsImg,
    },
    {
      stepTitle: i18next.t('EarnCertificates', { ns: 'whatsNewModal' }),
      stepDescription: i18next.t('PutYourKnowledgeToTheTest', { ns: 'whatsNewModal' }),
      stepImage: earnCertificatesImg,
    },
  ],
};
